import { EmpWellnessCarousel, HubspotBrochureDownload } from '.'

const EmpWellnessCalendar = (props) => {
  return (
    <>
      <section className="contentmainN ptb0 pt-5">
        <div className="container customCampaignContainer">
          <div className="row d-flex align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 ">
              <div className="subTextHeading text-left">You will get to learn:</div>
              <div>
                <ul className="mainbullets mt-4">
                  <li>Tips to create theme centric monthly employee wellness calendar.</li>
                  <li>How to set wellness goals aligning with the calendar.</li>
                  <li>How a standard employee wellness calendar looks like.</li>
                  <li>Communication and promotion strategies.</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center" id="implementationCarousel">
              <EmpWellnessCarousel />
            </div>
          </div>
        </div>
      </section>
      <div id="downloadForm"></div>
      <section className="sectionSpacing">
        <div className="container customCampaignContainer">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-12 col-lg-6 col-lg-offset-2 text-center shadow"
              style={{ margin: 'auto', borderRadius: '16px', padding: '60px 30px' }}
            >
              <div className="mainHeadingN ">Download Now</div>
              <div className="innerSpace guide-form">
                <HubspotBrochureDownload formID="e176026a-fb2f-40fa-933e-2389319a8c1c" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default EmpWellnessCalendar
